function init() {

    // monthly listing on events archive
    if ( jQuery('.post-type-archive-event').length ) {

        // insert month headers
        let thrice = '';
        jQuery('.article-block-grid .m-event-card__vertical').each(function() {
            let start = jQuery(this).data('start');
            if ( thrice != start ) {
                thrice = start;
                jQuery('<h2>' + start + '</h2>').insertBefore(this);
            }
        });

        // show ten hidden events and their month headers
        function showEvents() {
            jQuery('.article-block-grid .m-event-card__vertical:hidden:lt(10)').slideDown(260);
            jQuery('.article-block-grid h2').each(function() {
                if ( jQuery(this).next('.m-event-card__vertical').is(':visible') ) {
                    jQuery(this).show();
                }
            });
            const count = jQuery('.m-event-card__vertical:hidden').length; // count remaining hidden events
            if ( count > 0 ) { // show load more button if hidden events remain
                jQuery('#loadMoreEvents').css('display', 'inline-block');
            }
            else {
                jQuery('#loadMoreEvents').hide();
            }
        }
        // show first ten events
        showEvents();        

        // load more 
        jQuery('#loadMoreEvents').on('click', function() {
            showEvents();
        });
    }
}

export { init as default } 